export const enAnalytics = {
	title: "Analytics",
	export: "Export (.xlsx)",
	tabs: {
		overview: "List & Campaign Overview",
		topCampaigns: "Top campaigns",
		campaignDeepDive: "Campaign Deep Dive",
		userDeepDive: "User Deep Dive",
		signals: "Profile Tracker Signals",
	},
	datePlaceholder: "Select Date Range",
	lifetime: "Lifetime",
	filters: {
		list: "List",
		campaign: "Campaign",
		sender: "Sender",
		sendingUser: "Sending user",
		date: "Date",
		period: "Period",
		all: "All",
		countSelected: "{{count}} selected",
		countOf: "{{count}} of {{total}}",
		allLists: "All lists",
		allCampaigns: "All campaigns",
		allSenders: "All senders",
		quickFilters: "Quick filters",
		allListsWithLeads: "All lists with leads",
		allListsWithCampaigns: "All lists with campaigns",
		searchLists: "Search lists…",
		loadMoreLists: "Show more lists",
		noLists: "No lists found",
		noCampaigns: "Select a list first",
		noSenders: "No sending users found",
	},
	selectLists: "Select Lists",
	selectedCampaigns: "Selected Campaigns",
	overview: {
		groups: {
			details: "Campaign details",
			overview: "Overview",
			linkedin: "LinkedIn",
			email: "E-Mail",
		},
		collapseGroup: "Collapse column group",
		expandGroup: "Expand column group",
		columns: {
			listCampaign: "List / Campaign",
			channels: "Channels",
			senders: "Senders",
			lastActivity: "Last activity",
			leadsContacted: "Leads contacted",
			leadsEnded: "Leads ended",
			replyRate: "Reply %",
			positiveRate: "Positive %",
			sentiment: "Sentiment",
			ooo: "Out-of-office",
			acceptRate: "Accept %",
			openRate: "Open %",
			clickRate: "Click %",
			bounceRate: "Bounced %",
		},
		channels: {
			linkedin: "LinkedIn",
			email: "E-Mail",
		},
		activityKinds: {
			emailSent: "E-mail sent",
			emailReplyReceived: "E-mail reply received",
			linkedinMessageSent: "LinkedIn message sent",
			linkedinInmailSent: "LinkedIn InMail sent",
			linkedinInviteSent: "Connection request sent",
			linkedinReplyReceived: "LinkedIn reply received",
			profileVisited: "Profile visited",
			other: "Activity",
		},
		highlights: {
			activeCampaigns: "Currently active campaigns",
			totalCampaigns: "Total campaigns created",
			currentlyAssigned: "Currently assigned leads",
			assignedInPeriod: "Assigned in period",
		},
		footnote:
			"Reply and positive rates are measured against contacted leads. Sentiment is the share of replies that lean positive (interested or bad timing); out-of-office auto-replies are excluded.",
	},
	top: {
		title: "Top performance · all time",
		lifetimeRow: "Lifetime performance",
		columns: {
			campaign: "Campaign",
			assigned: "Assigned",
			contacted: "Contacted",
			replyRate: "Reply rate",
			positiveRate: "Positive reply rate",
			sentiment: "Sentiment",
		},
		noneRanked:
			"No campaign has contacted at least {{count}} leads yet — there is not enough volume to rank one above another.",
		footnote:
			"Ranked by reply rate over contacted leads, all time and across every list. Campaigns with fewer than {{count}} contacted leads are left out: a two-of-two campaign reads as 100% and would outrank everything.",
	},
	actions: {
		viewCampaign: "View campaign",
		viewLeads: "View leads",
		viewCampaignMulti: "A campaign's steps can only be viewed one at a time. Pick which one:",
		viewLeadsMulti:
			"You've selected multiple lists. Open one list's leads, or all of them together in Contacts:",
		allLists: "All selected lists",
		allListsSubtitle: "deduplicated Contacts view",
		allListsWarning:
			"Heads up: a lead that sits in several lists appears once in Contacts, so its First / Last / Best sentiment reflects only one of them.",
	},
	campaignModal: {
		subtitle: "{{count}} steps · {{list}}",
		openBuilder: "Open campaign builder",
		noSteps: "This campaign has no steps configured yet.",
		wait: "Wait {{count}} day",
		wait_other: "Wait {{count}} days",
		steps: {
			linkedinInvite: "LinkedIn connection request",
			linkedinMessage: "LinkedIn message",
			linkedinInmail: "LinkedIn InMail",
			linkedinVisit: "Profile visit",
			linkedinRemoveInvite: "Withdraw connection request",
			email: "E-Mail",
		},
	},
	users: {
		sentTitle: "Sent messages",
		scheduledTitle: "Scheduled messages",
		metricColumn: "Metric",
		today: "Today",
		groups: {
			linkedin: "LinkedIn",
			email: "E-Mail",
		},
		rows: {
			maxConnections: "Max. LinkedIn connections",
			sentConnections: "Sent connections",
			acceptedConnections: "Accepted connections",
			maxMessages: "Max. LinkedIn messages",
			sentMessages: "Sent messages",
			linkedinReplies: "LinkedIn replies",
			linkedinPositiveReplies: "Positive LinkedIn replies",
			maxEmails: "Max. sent e-mails",
			sentEmails: "Sent e-mails",
			emailsOpened: "E-mails opened",
			emailsClicked: "E-mails clicked",
			emailsReplied: "E-mails replied",
			emailsPositiveReplies: "E-mails positive replies",
			emailsBounced: "E-mails bounced",
			scheduledConnections: "Scheduled connections",
			scheduledMessages: "Scheduled messages",
			scheduledEmails: "Scheduled e-mails",
			creditsSpent: "Credits spent (all users)",
		},
		attributionHint:
			"Replies and accepted invites carry no sender of their own, so each is credited to the last user who sent to that lead. For a lead worked by two senders it lands on whoever touched it most recently. Sends, opens, clicks and bounces are exact.",
		scopeNote:
			"Daily caps are a property of the sending user, so they are never narrowed by the filters above — only the sends and queued work are.",
		listScopeNote:
			"Scoped to the selected lists. The caps each row is measured against stay per user, and the credit-spend row stays company-wide — usage is not recorded per list.",
		periodClampNote:
			"The grid shows at most the last {{count}} days, so a longer period is trimmed to that.",
		footnote:
			"Days are UTC. Caps are read-only here — change them in the sending user's settings or the mailbox. Credit spend is company-wide: usage is not recorded per user, so it cannot be split.",
	},
	signals: {
		title: "Profile tracker signals",
		byMonth: "by month",
		uniqueCompanies: "companies",
		groups: {
			tracking: "Tracking",
			outreach: "Outreach from signals",
		},
		columns: {
			month: "Month",
			trackedProfiles: "Tracked profiles",
			newSignals: "New signals",
			leadsContacted: "Leads contacted",
			leadsEnded: "Leads ended",
			replyRate: "Reply rate",
			positiveReplies: "Positive replies",
			sentiment: "Sentiment",
		},
		untrackedSelection:
			"The selected lists have no profile tracker, so there are no signals to report. Signals come from tracked lists — {{count}} other list is tracked in this company.",
		untrackedSelection_other:
			"The selected lists have no profile tracker, so there are no signals to report. Signals come from tracked lists — {{count}} other lists are tracked in this company.",
		partiallyTracked:
			"Only {{tracked}} of the {{selected}} selected lists have a profile tracker. The rest contribute nothing to these numbers.",
		senderScopeNote:
			"The sender filter narrows the outreach columns only. Tracked profiles and new signals are collected by the tracker, not sent by a user, so those columns stay company-wide.",
		noTrackersAtAll: "No profile tracker has been set up yet, so there are no signals to report.",
		footnote:
			"Tracked profiles are a month-end count, not additions during the month. Outreach counts leads that came from a signal, in the month they were added to a campaign — a signal found in May can show up as outreach in July.",
	},
	compare: {
		start: "Compare campaigns",
		stop: "Stop comparing",
		columnA: "Column A",
		columnB: "Column B",
		emptyTitle: "Compare lists and campaigns side by side",
		emptyBody:
			"Pick a list and campaign above to compare it with the column on the left. Each column keeps its own date range, so you can also compare one campaign across two periods.",
	},
	emptyTitle: "No data found for your current selection",
	emptyBody:
		"Pick one or more lists above or a different timeframe to see analytics for your campaigns.",
	timeframe: {
		NOW: "Now",
		DAY: "Yesterday",
		THIS_WEEK: "This week",
		LAST_7_DAYS: "Last 7 days",
		LAST_30_DAYS: "Last 30 days",
		THIS_MONTH: "This month",
		LAST_MONTH: "Last month",
		THIS_YEAR: "This year",
		LAST_YEAR: "Last year",
		ALL_TIME: "All Time",
	},
	viewLeadsFor: "View leads for {{kpi}}",
	drillDown: "Drill down",
	drillDownTo: "Drill down to {{label}}",
	openInContacts: "Open in Contacts",
	openInContactsFor: "Open contacts for {{label}}",
	activeFilters: "Active filters",
	clearAllFilters: "Clear all",
	filterDimension: {
		seniority: "Seniority",
		jobTitle: "Job Title",
		geo: "Country",
		industry: "Industry",
	},
	breakdownTitle: "Breakdown",
	breakdownSubtitle: "Pick a dimension and a KPI to see the top-performing segments.",
	breakdownDimensionLabel: "Dimension",
	breakdownKpiLabel: "KPI",
	breakdownNoData: "No breakdown data available",
	breakdownBucketColumn: {
		seniority: "Seniority",
		jobTitle: "Job Title",
		geo: "Country",
		industry: "Industry",
	},
	breakdownBy: {
		seniority: "By Seniority",
		jobTitle: "By Job Title",
		geo: "By Geography",
		industry: "By Industry",
	},
	kpiLabel: {
		totalLeads: "Total Leads",
		assignedLeads: "Assigned",
		contactedLeads: "Contacted",
		endedCampaignLeads: "Ended Campaigns",
		totalRepliedLeads: "Replied",
		oooReplies: "Out-of-office",
		positiveReplies: "Positive",
		replyInterested: "Interested",
		replyBadTiming: "Bad Timing",
		replyWrongPerson: "Wrong Person",
		replyNotInterested: "Not Interested",
		replyNeutral: "Neutral",
	},
	hero: {
		totalLeads: "Total Leads",
		assignedLeads: "Assigned",
		replied: "Replied",
		positive: "Positive Replies",
		ofTotal: "of total",
		ofAssigned: "of assigned",
	},
	sections: {
		leads: {
			title: "Leads funnel",
			rows: {
				totalLeads: "Total Leads",
				foundLeads: "Found Leads",
				qualifiedLeads: "Qualified Leads",
				prio1Leads: "Prio 1 Leads",
				prio2Leads: "Prio 2 Leads",
				prio3Leads: "Prio 3 Leads",
				assignedLeads: "Assigned Leads",
			},
		},
		campaignFunnel: {
			title: "Campaign funnel",
			rows: {
				assignedLeads: "Assigned Leads",
				contactedLeads: "Contacted Leads",
				endedCampaignLeads: "Ended Campaigns",
				oooReplies: "Out-of-office Replies",
				totalRepliedLeads: "Replied Leads",
				positiveReplies: "Positive Replies",
				positiveSentiment: "Positive Sentiment",
			},
		},
		replyAnalysis: {
			title: "Reply Analysis",
			rows: {
				replyInterested: "Interested",
				replyBadTiming: "Bad Timing",
				replyWrongPerson: "Wrong Person",
				replyNotInterested: "Not Interested",
				replyNeutral: "Neutral",
			},
		},
		email: {
			title: "E-Mail Analytics",
			rows: {
				emailsSent: "Emails Sent (Unique)",
				emailOpened: "Emails Opened",
				emailClicked: "Emails Clicked",
				emailReplies: "Emails Replied",
				emailPositiveReplied: "Emails Positive Replied",
				emailUnsubscribed: "Emails Unsubscribed",
				emailBounced: "Emails Bounced",
			},
		},
		linkedin: {
			title: "LinkedIn Analytics",
			rows: {
				linkedinInviteSent: "Invites Sent",
				linkedinInvitesAccepted: "Invites Accepted",
				linkedinReplies: "Replies",
				linkedinPositiveReplied: "Positive Replies",
			},
		},
		credits: {
			title: "Credits",
			used: "Credits used",
			perQualified: "Per qualified lead",
			perReply: "Per reply",
			perPositive: "Per positive reply",
			campaignScopeHint:
				"Credit spend is recorded per list, not per campaign. With a campaign selected these figures count only the spend tied to a lead in it — enrichment and copywriting — and leave out list-level spend such as tracker runs and searches, so they read low.",
		},
	},
};
